// Static assets (all served locally from /public)
export const IMAGES = {
  ibkLogo: "/ibk-logo.webp",
  etg24Logo: "/etg24-logo.png",
  hero: "/assets/hero.jpg",
  portrait: "/assets/portrait.jpg",
  stuttgart: "/assets/stuttgart.jpg",
};

export const CERTIFICATES = [
  { id: "c1", img: "/assets/cert1.png", de: "Zertifizierter Verwalter — IHK Stuttgart, geprüft nach § 26a WEG", en: "Certified Administrator — IHK Stuttgart, examined under § 26a WEG", issuer: "IHK Stuttgart" },
  { id: "c2", img: "/assets/cert2.png", de: "Wohnimmobilienverwalterin — IHK Stuttgart, § 34c Abs. 1 GewO", en: "Residential Property Manager — IHK Stuttgart, § 34c GewO", issuer: "IHK Stuttgart" },
  { id: "c3", img: "/assets/cert3.png", de: "Finanzfachkraft — VHS Esslingen, Xpert Business", en: "Financial Specialist — VHS Esslingen, Xpert Business", issuer: "VHS Esslingen" },
  { id: "c4", img: "/assets/cert4.png", de: "Immobilienverwalterin — IHK Ulm geprüft", en: "Property Manager — Certified by IHK Ulm", issuer: "IHK Ulm" },
  { id: "c5", img: "/assets/cert4_2.png", de: "Immobilienverwalterin — Lehrgangsinhalte", en: "Property Manager — Course Contents", issuer: "IHK Ulm" },
  { id: "c6", img: "/assets/cert5.png", de: "Immobilienmaklerin — Zertifikat", en: "Real Estate Agent — Certificate", issuer: "IHK" },
];

export const CONTACT = {
  phone: "+49 7123 9476964",
  phoneHref: "tel:+4971239476964",
  email: "info@immobilienbetreuung-kern.de",
  address: "Rebenstr. 4, 72639 Neuffen",
  maps: "https://www.google.com/maps/place/Hausverwaltung+Immobilienbetreuung+Kern/@48.5498811,9.3286114,1573m",
  portal: "https://app.etg24.de/app/ibk-kern/account/login",
};

export const REGIONS = ["Nürtingen", "Frickenhausen", "Neuffen", "Kirchheim u. Teck", "Weilheim", "Ostfildern", "Stuttgart"];

export const T = {
  de: {
    nav: { home: "Home", services: "Leistungen", about: "Über uns", areas: "Einsatzgebiete", contact: "Kontakt" },
    hero: {
      kicker: "Hausverwaltung · Neuffen",
      l1: "Ihre Hausverwaltung",
      l2: "mit",
      l3: "Herz.",
      sub: "Fair. Ehrlich. Zuverlässig. Persönliche Immobilienbetreuung — auch für kleine Einheiten.",
      cta: "Kontakt aufnehmen",
      scroll: "Nach unten scrollen",
    },
    services: {
      label: "Leistungen",
      title: "Was wir für Sie übernehmen",
      items: [
        { t: "WEG-Verwaltung", d: "Moderne, effiziente Verwalter-Software und ein zuverlässiger Handwerkerpool — inklusive Sondereigentumsverwaltung." },
        { t: "Wertsicherung", d: "Werterhalt durch kompetente Sanierungsvorschläge und die Koordination Ihrer Handwerker." },
        { t: "Mietverwaltung", d: "Umfassende Betreuung aller Mietangelegenheiten — von A bis Z, transparent und persönlich." },
        { t: "Kundenportal etg24", d: "Zugang für Kunden: wichtige Dokumente jederzeit abrufbar und schnelle, einfache Kommunikation." },
        { t: "Betriebskostenabrechnung", d: "Wir übernehmen für Sie die lästigen Abrechnungen an die Mieter — korrekt und pünktlich." },
      ],
    },
    about: {
      label: "Über uns",
      title: "Hallo, ich bin Nicole Kern.",
      p1: "Meine berufliche Reise begann in der Bäckerei, doch meine Leidenschaft für Zahlen führte mich zur Buchhaltung und schließlich zur Immobilienverwaltung.",
      p2: "Hier vereine ich mein Fachwissen mit einem vielseitigen Arbeitsumfeld. Durch Weiterbildungen und Zertifizierungen biete ich meinen Kunden einen zuverlässigen, professionellen Service.",
      name: "Nicole Kern",
      role: "Geschäftsführerin",
      values: [
        { t: "Fair", d: "Transparente Kommunikation und ehrliche Beratung — ohne Kleingedrucktes." },
        { t: "Persönlich", d: "Feste Ansprechpartnerin, die Ihre Immobilie und Ihre Anliegen wirklich kennt." },
        { t: "Kompetent", d: "Laufende Weiterbildung und IHK-Zertifizierungen als Fundament jeder Entscheidung." },
      ],
    },
    certs: { label: "Zertifikate", title: "Meine Qualifikationen", sub: "Geprüft, zertifiziert, nachweisbar. Zum Vergrößern anklicken.", close: "Schließen", hint: "Klicken zum Vergrößern" },
    areas: { label: "Einsatzgebiete", title: "Wo wir für Sie da sind", sub: "Wir sind bereits in diesen Regionen für unsere Kunden aktiv." },
    contact: {
      label: "Kontakt",
      title: "Sprechen wir über Ihre Immobilie",
      phone: "Telefon", email: "E-Mail", hours: "Öffnungszeiten", address: "Adresse",
      h1: "Mo., Di., Do., Fr. 9–17 Uhr", h2: "Mi. 9–12 Uhr",
      cta: "E-Mail schreiben", route: "Route planen",
    },
    portal: { label: "Kundenportal", cta: "Zum etg24 Portal" },
    footer: { tagline: "Ihre Hausverwaltung mit Herz.", rights: "Alle Rechte vorbehalten.", back: "Nach oben" },
  },
  en: {
    nav: { home: "Home", services: "Services", about: "About", areas: "Areas", contact: "Contact" },
    hero: {
      kicker: "Property Management · Neuffen",
      l1: "Property management",
      l2: "with",
      l3: "heart.",
      sub: "Fair. Honest. Reliable. Personal property care — even for small units.",
      cta: "Get in touch",
      scroll: "Scroll down",
    },
    services: {
      label: "Services",
      title: "What we handle for you",
      items: [
        { t: "Condominium Management", d: "Modern, efficient management software and a reliable network of tradespeople — including special-property management." },
        { t: "Value Preservation", d: "Preserving value through expert renovation proposals and coordinating your tradespeople." },
        { t: "Rental Management", d: "Comprehensive care for all rental matters — from A to Z, transparent and personal." },
        { t: "etg24 Customer Portal", d: "Access for clients: important documents available anytime, plus fast and simple communication." },
        { t: "Operating Cost Statements", d: "We take the tedious tenant statements off your hands — accurate and on time." },
      ],
    },
    about: {
      label: "About",
      title: "Hi, I'm Nicole Kern.",
      p1: "My professional journey began in a bakery, but my passion for numbers led me to bookkeeping and finally to property management.",
      p2: "Here I combine my expertise with a varied working environment. Through continuous training and certifications, I offer my clients a reliable, professional service.",
      name: "Nicole Kern",
      role: "Managing Director",
      values: [
        { t: "Fair", d: "Transparent communication and honest advice — no fine print." },
        { t: "Personal", d: "A dedicated contact who truly knows your property and your concerns." },
        { t: "Expert", d: "Ongoing training and IHK certifications as the foundation of every decision." },
      ],
    },
    certs: { label: "Certificates", title: "My Qualifications", sub: "Examined, certified, verifiable. Click to enlarge.", close: "Close", hint: "Click to enlarge" },
    areas: { label: "Service Areas", title: "Where we work for you", sub: "We are already active for our clients across these regions." },
    contact: {
      label: "Contact",
      title: "Let's talk about your property",
      phone: "Phone", email: "Email", hours: "Opening hours", address: "Address",
      h1: "Mon, Tue, Thu, Fri 9am–5pm", h2: "Wed 9am–12pm",
      cta: "Write an email", route: "Get directions",
    },
    portal: { label: "Client Portal", cta: "Open etg24 Portal" },
    footer: { tagline: "Your property management with heart.", rights: "All rights reserved.", back: "Back to top" },
  },
};
